import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { IMAGE_GALLERY_BASE_CLASSNAME } from './Constants';
import { createImageGallery } from './ImageGallery';
createComponents(".".concat(IMAGE_GALLERY_BASE_CLASSNAME), createImageGallery, NO_PATTERN_BUSINESS_LOGIC);
